<label for="feature_{{feature.id}}">
  {{ feature.header }}<span *ngIf="feature.unitHeader">, {{ feature.unitHeader }}</span>
  <span *ngIf="isRequired()"> *</span>
  <span *ngIf="feature.comment" nbTooltip="{{feature.comment}}">
    <nb-icon icon="bulb-outline"></nb-icon>
  </span>
</label>

<div class="accordion-item__right">
  <form [formGroup]="form" style="width: 100%;">
    <tui-editor
      id="feature_{{feature.id}}"
      formControlName="featureValue"
      [style.max-height.px]="maxHtmlContentLength"
    >
    </tui-editor>
    <div *ngIf="featureValue.invalid && (featureValue.dirty || featureValue.touched)">
      <div *ngIf="featureValue.hasError('required')" class="text-danger" i18n="@@FeatureValueRequiredError">
        Поле обязательно для заполнения
      </div>
      <div *ngIf="featureValue.hasError('minlength')" class="text-danger" i18n="@@FeatureValueMinLengthError">
        Минимум {{ featureValue.errors.minlength.requiredLength }} символов
      </div>
      <div *ngIf="featureValue.hasError('maxlength')" class="text-danger" i18n="@@FeatureValueMaxLengthError">
        Превышен лимит символов: {{ featureValue.errors.maxlength.actualLength }} из {{ featureValue.errors.maxlength.requiredLength }}
      </div>
    </div>
  </form>
  <div class="accordion-item__right-info">
    <div class="state-warn" *ngIf="featureValue.valid && isShowEmptyWarning()">
      <nb-icon icon="alert-triangle-outline"/>
    </div>
    <div class="state-err" *ngIf="featureValue.invalid">
      <nb-icon icon="alert-circle-outline"/>
    </div>
    <div class="state-success" *ngIf="featureValue.valid && !isEmpty()">
      <nb-icon icon="checkmark-outline"/>
    </div>

    <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
       class="entityID"
       target="_blank"
       i18n-nbTooltip="@@OpenFeatureInNewWindow"
       nbTooltip="Открыть характеристику в новом окне"
       *ngIf="featureLink">
      #{{ feature.featureId }}
    </a>
  </div>
</div>
